import HttpClient from '../httpClient';

class JobApplyController extends HttpClient {
  saveResumeData = async (payload: object, token: string) => {
    const response = await this.client.post('/saveResumeData', payload, {
      headers: { Authorization: token },
    });
    return response.data;
  };

  submitApplication = async (payload: object, token: string) => {
    const response = await this.client.post('/createApplication', payload, {
      headers: { Authorization: token },
    });
    return response.data;
  };
}

export default new JobApplyController(process.env.REACT_APP_API_URL_ENTERPRISE);
